import {
  aiAgentsPath,
  aiApprovalsPath,
  aiChannelsPath,
  aiCronPath,
  aiDashboardPath,
  aiDebugPath,
  aiDevicesPath,
  aiDocumentationPath,
  aiKeysPath,
  aiLogsPath,
  aiModelsPath,
  aiNodesPath,
  aiPluginsPath,
  aiSessionsPath,
  aiSkillsPath,
  aiVoicePath,
} from '@logic'

import { lazyPage } from '@src/app/routes/lazy'

import { withAdminShell } from './components/AdminRouteHost'

// Lazy page imports — each becomes its own webpack chunk (FR-018 / SC-006).
const LazyChannelsPage = lazyPage(() => import('./pages/ChannelsPage'))
const LazySessionsPage = lazyPage(() => import('./pages/SessionsPage'))
const LazyApprovalsPage = lazyPage(() => import('./pages/ApprovalsPage'))
const LazyDashboardPage = lazyPage(() => import('./pages/DashboardPage'))
const LazyAgentsPage = lazyPage(() => import('./pages/AgentsPage'))
const LazySkillsPage = lazyPage(() => import('./pages/SkillsPage'))
const LazyPluginsPage = lazyPage(() => import('./pages/PluginsPage'))
const LazyCronPage = lazyPage(() => import('./pages/CronPage'))
const LazyModelsPage = lazyPage(() => import('./pages/ModelsPage'))
const LazyKeysPage = lazyPage(() => import('./pages/KeysPage'))
const LazyDocumentationPage = lazyPage(() => import('./pages/DocumentationPage'))
const LazyNodesPage = lazyPage(() => import('./pages/NodesPage'))
const LazyDevicesPage = lazyPage(() => import('./pages/DevicesPage'))
const LazyLogsPage = lazyPage(() => import('./pages/LogsPage'))
const LazyVoicePage = lazyPage(() => import('./pages/VoicePage'))
const LazyDebugPage = lazyPage(() => import('./pages/DebugPage'))

export type AdminRouteDefinition = {
  path: string
  component: React.ComponentType<any>
  /** When true, the route is matched exactly (used for `/ai` default). */
  exact?: boolean
  protected?: boolean
  redirect?: string
}

/**
 * Equabot admin route table — spec 028 / T010 + T011.
 *
 * Each route is wrapped in `AdminRouteHost` via `withAdminShell` so the
 * persistent nav, badge, and offline banner stay mounted across navigation.
 * Route guarding (in-app site admin) and page wrapping (asPage / withHeader)
 * are applied by `src/app/routes/routes.ts` when these are merged into the
 * top-level route table.
 */
export const equabotAdminRoutes: AdminRouteDefinition[] = [
  { path: aiDashboardPath, component: withAdminShell(LazyDashboardPage) },
  { path: aiChannelsPath, component: withAdminShell(LazyChannelsPage) },
  { path: aiSessionsPath, component: withAdminShell(LazySessionsPage) },
  { path: aiApprovalsPath, component: withAdminShell(LazyApprovalsPage) },
  { path: aiAgentsPath, component: withAdminShell(LazyAgentsPage) },
  { path: aiSkillsPath, component: withAdminShell(LazySkillsPage) },
  { path: aiPluginsPath, component: withAdminShell(LazyPluginsPage) },
  { path: aiCronPath, component: withAdminShell(LazyCronPage) },
  { path: aiModelsPath, component: withAdminShell(LazyModelsPage) },
  { path: aiKeysPath, component: withAdminShell(LazyKeysPage) },
  { path: aiDocumentationPath, component: withAdminShell(LazyDocumentationPage) },
  { path: aiNodesPath, component: withAdminShell(LazyNodesPage) },
  { path: aiDevicesPath, component: withAdminShell(LazyDevicesPage) },
  { path: aiLogsPath, component: withAdminShell(LazyLogsPage) },
  { path: aiVoicePath, component: withAdminShell(LazyVoicePage) },
  { path: aiDebugPath, component: withAdminShell(LazyDebugPage) },
]
